import { Reducer } from "redux";

import { ConversationActionTypes } from "./conversation-action-types";
import * as ConversationReducer from "./conversation-reducer";
import { MessageActionTypes } from "./message-action-types";
import * as MessageReducer from "./message-reducer";
import { ChatAction, IChatState } from "./types";

const initialState: IChatState = {
    conversations: {
        hasMore: false,
        hasFetched: false,
        isLoading: false,
        items: [],
        tabIds: [],
        unreadCountPersonConversations: 0,
        unreadCountGroupConversations: 0,
        messageToEdit: {},
        messageToReplyTo: {},
        pinnedMessages: {},
        isTyping: {},
        conversationsSkip: 0,
        groupsSkip: 0,
        usersSkip: 0,
    },
    messages: {
        isLoading: {},
        hasMore: {},
        virtuosoIndex: {},
        items: []
    },
}

const chatReducer: Reducer<IChatState, ChatAction> = (state = initialState, action) => {
    switch (action.type) {
        case ConversationActionTypes.QueryConversationsPending:
            return ConversationReducer.queryConversationsPending(state, action);

        case ConversationActionTypes.QueryConversationsRejected:
            return ConversationReducer.queryConversationsRejected(state, action);

        case ConversationActionTypes.QueryConversationsFulfilled:
            return ConversationReducer.queryConversationsFulfilled(state, action);

        case ConversationActionTypes.GetConversationFulfilled:
            return ConversationReducer.getConversationFulfilled(state, action);

        case ConversationActionTypes.SetTabState:
            return ConversationReducer.setTabState(state, action);

        case ConversationActionTypes.CreateConversationPeding:
            return ConversationReducer.createConversationPeding(state, action);

        case ConversationActionTypes.CreateConversationRejected:
            return ConversationReducer.createConversationRejected(state, action);

        case ConversationActionTypes.CreateConversationFulfilled:
            return ConversationReducer.createConversationFulfilled(state, action);

        case ConversationActionTypes.AddRemoteConversation:
            return ConversationReducer.addRemoteConversation(state, action);

        case ConversationActionTypes.MarkAsReadPending:
            return ConversationReducer.markAsReadPending(state, action);

        case ConversationActionTypes.MarkAsReadRejected:
            return ConversationReducer.markAsReadRejected(state, action);

        case ConversationActionTypes.LastReadReceived:
            return ConversationReducer.lastReadReceived(state, action);

        case ConversationActionTypes.AddIsTyping:
            return ConversationReducer.addIsTyping(state, action);

        case ConversationActionTypes.RemoveIsTyping:
            return ConversationReducer.removeIsTyping(state, action);

        case ConversationActionTypes.UpdateGroupActivityPending:
            return ConversationReducer.updateGroupActivity(state, action);

        case ConversationActionTypes.SetUnreadCountPersonConversations:
            return ConversationReducer.setUnreadCountPersonConversations(state, action);

        case ConversationActionTypes.SetUnreadCountGroupConversations:
            return ConversationReducer.setUnreadCountGroupConversations(state, action);

        case ConversationActionTypes.UpdateConversation:
            return ConversationReducer.updateConversation(state, action);

        case ConversationActionTypes.SetComposerReplyMessage:
            return ConversationReducer.setComposerReplyMessage(state, action);

        case ConversationActionTypes.SetComposerEditMessage:
            return ConversationReducer.setComposerEditMessage(state, action);

        case MessageActionTypes.AddMessageFulfilled:
            return MessageReducer.addMessageFulfilled(
                ConversationReducer.addMessageFulfilled(state, action),
                action);

        case MessageActionTypes.QueryMessagesPending:
            return MessageReducer.queryMessagesPending(state, action);

        case MessageActionTypes.QueryMessagesRejected:
            return MessageReducer.queryMessagesRejected(state, action);

        case MessageActionTypes.QueryMessagesFulFilled:
            return MessageReducer.queryMessagesFulFilled(state, action);

        case MessageActionTypes.RemoveMessageFulfilled:
            return MessageReducer.removeMessageFulfilled(state, action);

        case MessageActionTypes.PinMessageFulfilled:
            return MessageReducer.pinMessageFulfilled(state, action);

        case MessageActionTypes.UnpinMessageFulfilled:
            return MessageReducer.unpinMessageFulfilled(state, action);

        case MessageActionTypes.RemoveReaction:
        case MessageActionTypes.RemoveReactionPending:
        case MessageActionTypes.RemoveReactionFulfilled:
            return MessageReducer.removeReaction(state, action);

        case MessageActionTypes.AddReaction:
        case MessageActionTypes.AddReactionPending:
        case MessageActionTypes.AddReactionFulfilled:
            return MessageReducer.addReaction(state, action);

        case MessageActionTypes.SaveMessagePending:
            return MessageReducer.saveMessagePending(state, action);

        case MessageActionTypes.SaveMessageFulfilled:
            return MessageReducer.saveMessageFulfilled(
                ConversationReducer.saveMessageFulfilled(state, action),
                action);

        case MessageActionTypes.SaveMessageRejected:
            return MessageReducer.saveMessageRejected(state, action);

        case MessageActionTypes.MemoTodoUpdated:
            return MessageReducer.memoTodoUpdated(state, action);

        case MessageActionTypes.UpdateMessageFulfilled:
            return MessageReducer.updateMessageFullfilled(state, action);

        case MessageActionTypes.QueryPinnedMessagesFulfilled:
            return MessageReducer.queryPinnedMessagesFulfilled(state, action);

        default:
            return state;
    }
};

export default chatReducer;
